import {inject, Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {map, Observable} from 'rxjs';
import {PATH_FOR} from '@app/app.routes';
import {AuthService} from '@aviary/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotLoggedInGuard {

  private readonly authService: AuthService = inject(AuthService);
  private readonly router: Router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.getUser().pipe(
      map(user => !user || this.router.createUrlTree([PATH_FOR['DASHBOARD']]))
    );
  }

}
